import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/storage'

const config = {
  apiKey: "AIzaSyAUYXCXNgaygn1L1hWKnqwJGErHsu9TNMg",
  authDomain: "mcity-74f0e.firebaseapp.com",
  databaseURL: "https://mcity-74f0e.firebaseio.com",
  projectId: "mcity-74f0e",
  storageBucket: "mcity-74f0e.appspot.com",
  messagingSenderId: "154717556902",
  appId: "1:154717556902:web:a93a959e05c438040ce467",
  measurementId: "G-Y8F53HNEYG"
};
// Initialize Firebase
firebase.initializeApp(config);

const firebaseDB = firebase.database();
const firebaseMatches = firebaseDB.ref('matches');
const firebasePromotions = firebaseDB.ref('promotions');
const firebaseTeams = firebaseDB.ref('teams');
const firebasePlayers = firebaseDB.ref('players');

export {
    firebase,
    firebaseMatches,
    firebasePromotions,
    firebaseTeams,
    firebasePlayers,
    firebaseDB
}